// components/ExcelExportButton.js
import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import { exportReportsToExcel } from '../services/excelService';

const ExcelExportButton = () => {
    const [exporting, setExporting] = useState(false);

    const handleExport = async () => {
        try {
            setExporting(true);
            await exportReportsToExcel();
        } catch (error) {
            console.error('Excel export hatası:', error);
            alert('Excel dosyası oluşturulurken hata oluştu');
        } finally {
            setExporting(false);
        }
    };

    return (
        <Button 
            variant="success" 
            onClick={handleExport}
            disabled={exporting}
            className="me-2"
        >
            {exporting ? (
                <Spinner size="sm" animation="border" className="me-2" />
            ) : (
                <FaFileExcel className="me-2" />
            )}
            {exporting ? 'Excel Hazırlanıyor...' : 'Rapor Listesi (Excel)'}
        </Button>
    );
};

export default ExcelExportButton;